import React, { useContext, useEffect, useState } from 'react';
import classes from '../../../../../styles/AllDevices.module.css';
import Typography from '../../../../../components/Typography/Typography';
import Table from '../../../../../components/Table/Table';
import ModalComponent from '../../../../../components/ModalComponent/ModalComponent';
import cronClasses from '../CronJobs.module.css';
import { toast } from 'react-toastify';
import { START_LOADER, STOP_LOADER } from '../../../../../constants';
import { LoaderContext } from '../../../../../context/LoaderContext';
import { Form, Formik } from 'formik';
import DropDown from '../../../../../components/Inputs/Dropdown';
import { datahubLoggerRule } from '../../../../../validations/Root/cronJobsValidation';
import { CronService } from '../../../../../services/cronServices';
import { UilTrash, UilPen } from '@iconscout/react-unicons';
import DeleteModal from '../../../../../components/DeleteModal/DeleteModal';
import IconComponent from '../../../../../components/Icon/Icon';
import _ from 'lodash';

const SOURCE_OPTION = [
    { label: 'Nordpool', value: 'nordpool' },
    { label: 'Energinet', value: 'energinet' },
];

const DatahubLoggerRule = ({ config }) => {
    const [createModal, setCreateModal] = useState({ status: false, data: null });
    const [ruleData, setRuleData] = useState(config);
    const [tableData, setTableData] = useState([]);
    const [deleteModal, setDeleteModal] = useState({ status: false, id: '' });
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });

    useEffect(() => {
        formatedTableData();
    }, [ruleData]);

    const formatedTableData = () => {
        const processedData =
            ruleData.properties?.rules[0] &&
            ruleData.properties?.rules.map((item, index) => ({
                's.no': index + 1,
                source: item?.source,
                action: (
                    <div className="cronActionConatiner" style={{ gap: '0.5vw' }}>
                        <div onClick={() => setCreateModal({ status: true, data: item })}>
                            <IconComponent icon={UilPen} tooltip={'Edit'} />
                        </div>
                        <div conClick={() => setDeleteModal({ status: true, id: item.id })}>
                            <IconComponent icon={UilTrash} tooltip={'Delete'} />
                        </div>
                    </div>
                ),
            }));
        processedData ? setTableData(processedData) : setTableData([]);
    };

    const getRules = () => {
        CronService.GetRule(
            { id: ruleData?._id, type: 'datahubLoggerRules' },
            () => startLoader('getRule'),
            handleGetRuleSuccess,
            handleError,
            () => stopLoader('getRule')
        );
    };

    const handleGetRuleSuccess = ({ data }) => {
        setRuleData(data.data[0]);
    };

    const DeleteRule = () => {
        CronService.DeleteRule(
            ruleData._id,
            deleteModal.id,
            () => startLoader('deleteRule'),
            handleDeleteRuleSuccess,
            handleError,
            () => stopLoader('deleteRule')
        );
    };

    const handleDeleteRuleSuccess = () => {
        toast.success('Rule deleted!');
        getRules();
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const handleSubmit = (value) => {
        value['_id'] = config._id;
        if (createModal?.data?.id) {
            const payload = {
                cronId: config._id,
                ruleId: createModal?.data?.id,
                source: value.source,
            };
            CronService.EditRule(
                payload,
                () => startLoader('edit'),
                handleEditRuleSuccess,
                handleError,
                () => stopLoader('edit')
            );
        } else {
            CronService.AddRule(
                value,
                () => startLoader('addRule'),
                handleAddRuleSuccess,
                handleError,
                () => stopLoader('addRule')
            );
        }
    };

    const handleAddRuleSuccess = () => {
        toast.success('Rule added!');
        setCreateModal({ status: false, data: null });
        if (ruleData?._id) getRules();
    };

    const handleEditRuleSuccess = () => {
        toast.success('Rule updated!');
        setCreateModal({ status: false, data: null });
        if (ruleData?._id) getRules();
    };

    return (
        <div>
            <DeleteModal deletefunction={DeleteRule} opendeleteModal={deleteModal.status} setOpenDeleteModal={(status) => setDeleteModal({ ...deleteModal, status })}></DeleteModal>
            <div className={classes.AllDevices}>
                <ModalComponent isOpen={createModal.status} setOpen={() => setCreateModal({ status: false, data: null })} style={{ overflow: 'initial' }}>
                    <div style={{ height: 'auto', width: '20vw' }}>
                        <div className={cronClasses.ModalWrapper}>
                            <Typography content={createModal?.data?.id ? 'Update Rule' : 'Add Rule'} />
                        </div>

                        <div className={classes.FormContent}>
                            <Formik
                                initialValues={{
                                    source: _.get(createModal, ['data', 'source'], SOURCE_OPTION[0].value),
                                }}
                                enableReinitialize
                                validationSchema={datahubLoggerRule}
                                onSubmit={(val, { resetForm }) => handleSubmit(val, resetForm)}
                            >
                                {({ errors, touched, values, isValidating, ...props }) => {
                                    return (
                                        <Form>
                                            <div className={classes.FieldControl2}>
                                                <label className={cronClasses.label}>
                                                    Select Source <span className="required">*</span>
                                                </label>
                                                <DropDown name="source" options={SOURCE_OPTION} defaultValue={{ value: values?.source }} />
                                            </div>

                                            <div>
                                                <div style={{ display: 'flex', gap: '0.4vw' }}>
                                                    <button className="btn-secondary" onClick={() => setCreateModal({ status: false, data: null })}>
                                                        Cancel
                                                    </button>
                                                    <button type="submit" className="btn-primary">
                                                        {createModal?.data?.id ? 'Update' : 'Add'}
                                                    </button>
                                                </div>
                                            </div>
                                        </Form>
                                    );
                                }}
                            </Formik>
                        </div>
                    </div>
                </ModalComponent>
                <div className={classes.Header}>
                    <div>
                        <Typography content="Datahub logger Rules" />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={tableData.length} />
                            </span>
                        </div>
                        <div>
                            <button type="submit" className="btn-primary" style={{ marginTop: '0' }} onClick={() => setCreateModal({ status: true, data: null })}>
                                Add Rule
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <Table head={['S.No', 'Source', 'Action']} keys={['s.no', 'source', 'action']} data={tableData} />
                </div>
            </div>
        </div>
    );
};

export default DatahubLoggerRule;
